import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "lines-surface" }
const _hoisted_2 = { class: "v-data-table-group-header-row" }
const _hoisted_3 = ["colspan"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href", "innerHTML"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_LinePricingInfo = _resolveComponent("LinePricingInfo")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_SuggestedPriceEditor = _resolveComponent("SuggestedPriceEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            label: "Search",
            "single-line": "",
            "hide-details": "",
            "prepend-inner-icon": "mdi-magnify",
            class: "table-search"
          }, null, 8, ["modelValue"]),
          (_ctx.filteredColumnsDefs.length && _ctx.rowsData.length)
            ? (_openBlock(), _createBlock(_component_v_data_table, {
                key: 0,
                items: _ctx.rowsData,
                headers: _ctx.filteredColumnsDefs,
                "item-value": _ctx.itemKey,
                search: _ctx.search,
                "items-per-page": -1,
                "custom-key-sort": _ctx.customKeySort,
                class: "so-lines-table",
                density: "compact",
                "group-by": (_ctx.groupBy as any),
                "sort-by": (_ctx.sortBy as any),
                "fixed-header": "",
                height: _ctx.calcTableHeight
              }, {
                "group-header": _withCtx(({ item, toggleGroup, isGroupOpen }) => [
                  _createElementVNode("tr", _hoisted_2, [
                    _createElementVNode("td", {
                      colspan: _ctx.filteredColumnsDefs.length,
                      class: "group-header-cell"
                    }, [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "text",
                        icon: isGroupOpen(item) ? '$expand' : '$next',
                        class: "group-toggle-btn",
                        onClick: ($event: any) => (toggleGroup(item))
                      }, null, 8, ["icon", "onClick"]),
                      _createElementVNode("span", null, _toDisplayString(item.value) + " (" + _toDisplayString(item.items.length) + ")", 1)
                    ], 8, _hoisted_3)
                  ])
                ]),
                item: _withCtx(({ item, index }) => [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumnsDefs, (columnDef, colIndex) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: colIndex,
                        onClick: ($event: any) => (_ctx.onCellClick(index, columnDef, item, $event)),
                        class: _normalizeClass(_ctx.getCellClass(columnDef))
                      }, [
                        (columnDef.key === 'suggestedPrice' && _ctx.shouldUsePricingInfo(item))
                          ? (_openBlock(), _createBlock(_component_LinePricingInfo, {
                              key: 0,
                              price: item.pricingInfo.price,
                              "price-type": item.pricingInfo.priceType,
                              "price-source": item.pricingInfo.priceSource,
                              references: item.pricingInfo.references,
                              pricelist: item.pricingInfo.pricelist,
                              "base-price": item.pricingInfo.basePrice,
                              "per-meter-adder": item.pricingInfo.perMeterAdder,
                              "length-unit": item.pricingInfo.lengthUnit,
                              clickable: ""
                            }, null, 8, ["price", "price-type", "price-source", "references", "pricelist", "base-price", "per-meter-adder", "length-unit"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.getTooltipText(columnDef, item) !== '')
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    activator: "parent"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", {
                                        innerHTML: _ctx.getTooltipText(columnDef, item)
                                      }, null, 8, _hoisted_5)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (_ctx.isClickable(columnDef.key) && _ctx.clickableCellHrefFn)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: _ctx.clickableCellHrefFn(item),
                                    class: "cell-link",
                                    innerHTML: _ctx.formattedValue(columnDef, item[columnDef.key], item)
                                  }, null, 8, _hoisted_6))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    innerHTML: _ctx.formattedValue(columnDef, item[columnDef.key], item)
                                  }, null, 8, _hoisted_7)),
                              (_ctx.getTooltipText(columnDef, item) !== '' && columnDef.key === 'suggestedPrice')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 3,
                                    icon: _ctx.getIcon(item),
                                    color: "#0000FF",
                                    size: "x-small",
                                    class: "ml-1"
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true)
                            ], 64)),
                        _createElementVNode("span", null, [
                          (columnDef.key === 'partNumber' && item.isHigherLengthThanEverSold)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                icon: "mdi-exclamation-thick"
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_tooltip, { activator: "parent" }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createElementVNode("span", null, "Exceeds max length sold", -1)
                            ])),
                            _: 1
                          })
                        ])
                      ], 10, _hoisted_4))
                    }), 128))
                  ])
                ]),
                bottom: _withCtx(() => _cache[6] || (_cache[6] = [])),
                _: 1
              }, 8, ["items", "headers", "item-value", "search", "custom-key-sort", "group-by", "sort-by", "height"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AppDialog, {
      modelValue: _ctx.isEditing,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isEditing) = $event)),
      title: _ctx.editDialogTitle,
      "max-width": _ctx.isTextareaColumn(_ctx.editedColumnKey) ? 400 : 300,
      "cancel-text": "Cancel",
      "confirm-text": "Save",
      onConfirm: _ctx.saveEdit,
      onCancel: _ctx.cancelEdit
    }, {
      default: _withCtx(() => [
        (!_ctx.isTextareaColumn(_ctx.editedColumnKey))
          ? (_openBlock(), _createBlock(_component_v_text_field, {
              key: 0,
              modelValue: _ctx.editedValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editedValue) = $event)),
              ref: "editInput",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              "single-line": "",
              autofocus: "",
              class: "mt-1",
              onKeyup: [
                _withKeys(_ctx.saveEdit, ["enter"]),
                _withKeys(_ctx.cancelEdit, ["esc"])
              ]
            }, null, 8, ["modelValue", "onKeyup"]))
          : (_openBlock(), _createBlock(_component_v_textarea, {
              key: 1,
              modelValue: _ctx.editedValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editedValue) = $event)),
              ref: "editTextarea",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              autofocus: "",
              class: "mt-1",
              onKeyup: [
                _withKeys(_withModifiers(_ctx.saveEdit, ["ctrl"]), ["enter"]),
                _withKeys(_withModifiers(_ctx.saveEdit, ["shift"]), ["enter"]),
                _withKeys(_ctx.cancelEdit, ["esc"])
              ]
            }, null, 8, ["modelValue", "onKeyup"]))
      ]),
      _: 1
    }, 8, ["modelValue", "title", "max-width", "onConfirm", "onCancel"]),
    _createVNode(_component_SuggestedPriceEditor, {
      modelValue: _ctx.isPriceEditorOpen,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isPriceEditorOpen) = $event)),
      item: _ctx.priceEditorItem,
      loading: _ctx.priceEditorLoading,
      onSave: _ctx.onPriceEditorSave
    }, null, 8, ["modelValue", "item", "loading", "onSave"])
  ]))
}